export const formatAsCurrency = (value: number = 0, decimals: number = 2): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(value)
}

export const formatAsNumber = (value: number = 0, decimals: number = 2): string => {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(value)
}

export const formatAsPercentage = (value: number = 0, decimals: number = 2): string => {
  const result = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(value)
  return `${result}%`
}

export const phoneNumberMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

export const phoneRegExp = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/

/**
 * Formats consecutive numbers with hyphens (e.g., "1,2,3,4" becomes "1-4")
 * Handles both comma-separated and slash-separated groups (e.g., "1,2,3/4,5,6" becomes "1-3/4-6")
 * @param numbers A string of numbers separated by commas and/or slashes
 * @returns Formatted string with ranges using hyphens
 */
export const formatConsecutiveWagerNumbers = (numbers: string) => {
  if (!numbers || numbers.length === 0) return ''

  // Split by slash to handle groups separately
  const groups = numbers.split('/')
  
  const formattedGroups = groups.map(group => {
    // Split the comma-separated string into an array of numbers
    const sortedNumbers = group.split(',').map(Number).sort((a, b) => a - b)

    // Check if we have valid numbers
    if (sortedNumbers.some(isNaN)) return group

    let result = []
    let rangeStart = sortedNumbers[0]
    let rangeEnd = rangeStart

    for (let i = 1; i < sortedNumbers.length; i++) {
        // If current number is consecutive to previous one
        if (sortedNumbers[i] === rangeEnd + 1) {
            rangeEnd = sortedNumbers[i]
        } else {
            // Add the completed range to result
            if (rangeStart === rangeEnd) {
                result.push(`${rangeStart}`)
            } else {
                result.push(`${rangeStart}-${rangeEnd}`)
            }
            // Start a new range
            rangeStart = rangeEnd = sortedNumbers[i]
        }
    }

    // Add the last range
    if (rangeStart === rangeEnd) {
        result.push(`${rangeStart}`)
    } else {
        result.push(`${rangeStart}-${rangeEnd}`)
    }

    return result.join(',')
  })

  return formattedGroups.join('/')
}
